<template>

  <header class="" :class="{'expanded': headerExpanded}">

      <div class="mobile-nav-click" @click="headerExpanded = !headerExpanded">

      </div>
      <div class="mobile-nav-menu" v-html="headerExpanded ? 'Close' : 'Menu'">

      </div>

      <div class="logo">
        <!-- <router-link to="/"> -->
          <a href="https://hatopress.net">
          <!-- <img src="./assets/hatopress_logo_100x@2x.png" alt=""> -->
          Hato Press
          </a>
        <!-- </router-link> -->
      </div>
      <nav>
        <a href="https://hatopress.net/printing">Printing</a>
        <a >Workshops</a>
        <a href="https://shop.hatopress.net">Shop</a>
        <a href="https://hatopress.net/news">Journal</a>
        <a href="https://hatopress.net/about/">About</a>
        <a href="https://hatopress.net/contact/">Contact</a>

        <!-- <a href="">Printing</a>
        <a href="">Shop</a>
        <a class="active" href="">Workshops</a>
        <a href="">About</a>
        <a href="">Contact</a> -->
        <!-- <router-link to="/">Home</router-link> -->
        <!-- <router-link to="/projects">Projects</router-link> -->
        <!-- <router-link to="/projects">Projects</router-link> -->
        <!-- <router-link to="/news">News</router-link> -->
        <!-- <router-link to="/about">About</router-link> -->
        <!-- <router-link to="/contacts">Contacts</router-link> -->
      </nav>

      <!-- <transition name="fade">
        <router-link :to="{ name: 'Christmas' }" @click.native="showPopup = false" class="badge" v-if="!showPopup && $route.path !== '/christmas'">
          <div class="badge-background">

          </div>
          <div class="badge-text">Christmas Workshops for Groups&nbsp;or&nbsp;Teams&rarr;</div>
        </router-link>
      </transition> -->

      <!-- <transition name="fade">
        <div class="popup-wrapper" v-if="showPopup">
          <div class="popup">
            <div class="popup-image">

            </div>
            <div class="popup-text">
              <div class="close" @click="showPopup = false">
                &times;
              </div>
              <h2>Christmas Workshops for Groups or Teams</h2>
              <p>To find out about our Christmas and team workshops email us at &nbsp;<a href="mailto:bespoke@hatopress.net?subject=Christmas+Group+Workshop">bespoke@hatopress.net</a>
                <br><br>
                <router-link :to="{ name: 'Christmas' }" @click.native="showPopup = false" class="gold-hover">View Options &rarr;</router-link>
              </p>
            </div>
          </div>
        </div>
      </transition> -->
  </header>

</template>

<script>

export default {
  data () {
    return {
      showPopup: false,
      headerExpanded: false
    }
  },
  mounted () {
    if (this.$route.path !== '/christmas') {
      setTimeout(() => {
        this.showPopup = true
      }, 1500)
    } else {
      if (this.$route.hash === '#places') {
        setTimeout(() => {
          document.getElementById('places').scrollIntoView({
            behavior: 'smooth',
            block: 'start'
          })
        }, 500)
        // window.location.hash = '#places'
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

header {
  position: relative;
  /*position: sticky;*/
  top: 0;
  left: 0;
  right: 0;
  height: 3rem;
  z-index: 999999;
  background: white;
  width: 100%;
  padding: .75rem 1rem;
  display: flex;
  justify-content: space-between;
  justify-content: center;
  align-items: center;
}

.sticky {
  position: sticky;
  position: -webkit-sticky;
  top: 0;
}

.logo {
  position: relative;
  /*height: 1.3em;*/
  position: absolute;
  left: 0;
  top: 0;
  /*bottom: 0;*/
  height: 3rem;
  padding: 1rem;
  display: flex;
  align-items: center;
}
.logo a {
 /*position: absolute;
 left: 0;
 margin: 0;*/
 white-space: nowrap;
 margin: 0;
}

  .logo img {
    display: block;
    margin: 3px 0;
    pointer-events: none;
    width: auto;
    height: 20px;
    height: 1rem;
  }

nav {
  width: 700px;
  max-width: 60%;
  display: flex;
  justify-content: flex-end;
  justify-content: space-between;
  margin: 0 auto;
}

nav a {
  margin: 0.3em 1em 0;
  /*font-size: 2.5em;*/
}

nav {
  /*max-width:800px;*/
  width: 100%;
  max-width: 100%;
  border: 0;
  justify-content: center;
}
a {
  padding: .5em 1.5em;
  margin: 0 .5em;
  border-radius: 2em;
  text-align: center;
  background: #eee;
  border: 1px solid white;

  padding: 0em 0em 0em;
  margin: 0 2em;
  border-radius: 0;
  text-align: center;
  background: transparent;
  border: 0;
  line-height: 1rem;
}
a:hover {
  opacity: 0.5;
  /*border: 1px solid #000;*/
}
/*a:nth-child(1) {
  background: #eee
}
a:nth-child(2) {
  background: #eee
}
a:nth-child(3) {
  background: #eee
}*/
.router-link-active {
  /*background: #ccc;*/
  /*border-bottom: 1.2px solid #000;*/
  /*background: red;*/
}






.mobile-nav-click {
  position: absolute;
  top: 0;
  right: 0;
  left: 120px;
  height: 3rem;
  z-index: 999;
  display: none;
  pointer-events: none;
  background: rgba(0,0,0,0)
}
.mobile-nav-menu {
  position: absolute;
  right: 0;
  top: 0;
  /*bottom: 0;*/
  height: 3rem;
  padding: 1rem;
  display: flex;
  align-items: center;
  display: none;
}

@media screen and (max-width: 1024px) {
  header {
    justify-content: flex-end;
  }
  .logo a {
    /*position: relative;*/
  }
  nav {
    max-width: 100%;
    margin: 0;
    width: auto;
    justify-content: flex-end;
  }
  nav a {
    margin: 0 0 0 1.5em;
  }
}

@media screen and (max-width: 768px) {
  nav a {
    margin: 0 0 0 1.5em;
  }
}
@media screen and (max-width: 640px) {
  header {
    display: block;
    align-items: center;
    padding: 0;
  }
  /*.logo, nav {
    height: 3rem;
  }*/
  .logo {
    /*height: auto;*/
  }
  nav {
    /*min-width: 400px;*/
    position: absolute;
    top: 5rem;
    left: 0;
    right: 0;
    bottom: 5rem;
    /*padding-top: 3rem;
    padding-bottom: 3rem;*/
    /*margin-top: 3rem;*/
    display: none;
    /*fle*/
    align-items: center;
    justify-content: space-around;
    flex-wrap: wrap;
    flex-direction: column;
  }
  nav a {
    width: 100%;
    margin: 0;
  }
  /*nav a {
    margin: 0;
    display: none;
  }
  nav a.active {
    display: inline;
  }*/
  .mobile-nav-menu {
    display: block;
    display: flex;
  }
  .mobile-nav-click {
    display: block;
    pointer-events: auto;
  }

  header.expanded {
    height: auto;
    background: red;
    padding-top: 3rem;
    overflow: auto;
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 999999;
    background: #eee;
  }
  .expanded nav {
    display: flex;
  }
}

.popup-wrapper {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 9999;
  background: rgba(0,0,0,0.4)
}
.popup {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  margin: auto;
  background: white;
  background: rgb(243, 243, 243);
  /* background: rgb(33, 64, 43); */
  color: rgb(177, 123, 66);
  height: 25em;
  width: 50em;
  padding-left: 25em;
  box-shadow: 0 5px 20px 0px rgba(0,0,0,0.2)
}

.popup h2 {
  margin: 0 0 1em 0;
  line-height: 1.4;
  color: rgb(213, 155, 95);
}
.popup a {
  margin: 0;
  display: inline-block;
  position: relative;
  /* border-bottom: .6em solid rgba(177, 123, 66, .3); */
  height: 1.2em;
  display: inline-block;
}

.popup a.gold-hover {
  margin: 0;
  display: inline-block;
  position: relative;
  border-bottom: .6em solid #eac282;
  height: 1.2em;
  display: inline-block;
}
/* .popup a:after {
  content: "";
  position: absolute;
  top: 0;
  z-index: 0;
  display: block;
  width: 100%;
  height: 1em;
  background: gold;
} */

.popup .popup-text {
  padding: 3em 3em;
  height: 100%;
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}

.popup .popup-text .close {
  position: absolute;
  right: 0;
  top: 0;
  width: 1em;
  height: 1em;
  text-align: center;
  line-height: 1em;
  font-size: 2.5em;
  font-family: Avenir, Arial, sans-serif;
  font-weight: 200;
  opacity: 0.3;
  cursor: pointer;
}

.popup .popup-image {
  position: absolute;
  left: 0;
  top: 0;
  height: 100%;
  width: 50%;
  background-size: cover;
  background-image: url('https://assets.hato.co/b1/assets/workshops/HatoPress-Risograph-Workshop-Christmas-(Wrapping-Paper)-2400-0491.jpg');
}

.badge {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 250px;
  height: 100px;
  margin: 1rem;
  display: flex;
  justify-content: center;
  align-items: center;
  box-shadow: 0 3px 5px 0px rgba(0,0,0,0.4);
  border-radius: 10px;
  background: rgb(210, 177, 119);
  background: #142e1b;
  background: #fff;
  overflow: hidden;
}
.badge-background {
  position: absolute;
  left: 0;
  top: 0;
  height: 100%;
  width: 100%;
  z-index: 0;
  border-radius: 10px;
  background-size: 130%;
  background-position: right 70%;
  background-image: url('https://assets.hato.co/b1/assets/workshops/HatoPress-Risograph-Workshop-Christmas-(Wrapping-Paper)-2400-0491.jpg');
  opacity: .8;
}
.badge:hover {
  opacity: 1;
  transform: translateY(-3px);
  box-shadow: 0 5px 8px 0px rgba(0,0,0,0.4);
}

.badge-text {
  position: relative;
  z-index: 9;
  width: 100%;
  font-size: .9rem;
  color: rgb(231, 210, 173);
  color: #000;
  line-height: 1.5;
  font-weight: 400;
}

@media screen and (max-width: 1024px) {
  .popup-wrapper {
    background: rgba(0,0,0,0.5)
  }
  .popup {
    height: 90vw;
    width: 90vw;
    padding-left: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
  }
  .popup .popup-text {
    position: relative;
    z-index: 9;
    background: white;
    padding: 1em 2em;
    /* width: 80vw;
    height: 80vw; */
  }
  .popup .popup-text .close {
    opacity: 1;
  }
  .popup .popup-image {
    position: relative;
    width: 100%;
    display: none;
  }
  .popup p {
    margin-bottom: 0
  }
  .badge {
    width: auto;
    right: 0;
    height: 80px;
  }
  .badge-text {
    font-size: 1.2rem;
  }
}

.fade-enter-active, .fade-leave-active {
  transition: opacity .5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>



// WEBPACK FOOTER //
// NavMain.vue?4c3301ce